import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { apiMethods, apiEndPoints } from '@constants/index';
import { Observable } from 'rxjs';
import {
  IApiResponse,
  IVerifyOtp,
  ISignupApiDto,
  IResendOtp,
  IResendApiResponse,
  IConfirmOtpResponse,
  IResetPasswordResponse,
  IUpdatePassword
} from '@core/models';

@Injectable()
export class UserService {
  constructor( private readonly http: ApiService ) { }

  public registerUser( userData: ISignupApiDto ): Observable<IApiResponse> {
    return this.http.invoke( {
      method: apiMethods.post,
      path: `${ apiEndPoints.accounts }${ apiEndPoints.signUp }`,
      body: userData
    } );
  }

  public confirmOtp( postData: IVerifyOtp ): Observable<IConfirmOtpResponse> {
    return this.http.invoke( {
      method: apiMethods.post,
      path: `${ apiEndPoints.accounts }${ apiEndPoints.confirmOtp }`,
      body: postData
    } );
  }

  public resendOtp( postData: IResendOtp ): Observable<IResendApiResponse> {
    return this.http.invoke( {
      method: apiMethods.post,
      path: `${ apiEndPoints.accounts }${ apiEndPoints.resendOtp }`,
      body: postData
    } );
  }

  public sendForgotPassword( postData ): Observable<IResetPasswordResponse> {
    return this.http.invoke( {
      method: apiMethods.post,
      path: `${ apiEndPoints.accounts }${ apiEndPoints.forgotPassword }`,
      body: postData
    } );
  }
  public resetPassword( postData ): Observable<IResetPasswordResponse> {
    return this.http.invoke( {
      method: apiMethods.post,
      path: `${ apiEndPoints.accounts }${ apiEndPoints.resetPassword }`,
      body: postData
    } );
  }

  public updatePassword(postData: IUpdatePassword): Observable<IApiResponse> {
    return this.http.invoke({
      method: apiMethods.post,
      path: `${apiEndPoints.accounts}${apiEndPoints.updatePassword}`,
      body: postData
    });
  }

  public fetchProfileData( userId: number ): Observable<IApiResponse> {
    return this.http.invoke( {
      method: apiMethods.get,
      path: `${ apiEndPoints.accounts }${ apiEndPoints.myProfile }/${ userId }`,
    } );
  }

  public updateProfile( formData, userId ): Observable<IApiResponse> {
    return this.http.invoke( {
      method: apiMethods.patch,
      path: `${ apiEndPoints.accounts }${ apiEndPoints.myProfile }/${ userId }`,
      body: formData,
    } );
  }
}
